export default __webpack_public_path__ + "static/media/i-speedometer.bd9cfe46.svg";